import { ApolloCache } from '@apollo/client';
import {
  ConversationDocument,
  ConversationFragment,
  ExternalMessageFragment,
  GetConversationExternalMessagesDocument,
  GetConversationExternalMessagesQuery,
} from '@shared/generated/graphql';

export function writeConversationToCache(
  cache: ApolloCache<unknown>,
  conversation: ConversationFragment
): void {
  cache.writeQuery({
    query: ConversationDocument,
    variables: { id: conversation.id },
    data: { conversationById: conversation },
  });
}

export function markConversationWorkingInCache(
  cache: ApolloCache<unknown>,
  conversationId: string
): void {
  cache.modify({
    id: cache.identify({ __typename: 'Conversation', id: conversationId }),
    fields: { hasActionExecutionInProgress: () => true },
  });
}

export function appendChatMessageToCache(
  cache: ApolloCache<unknown>,
  conversationId: string,
  message: ExternalMessageFragment
): void {
  const variables = { input: { conversationId, includeMirrored: true } };
  const existing = cache.readQuery<GetConversationExternalMessagesQuery>({
    query: GetConversationExternalMessagesDocument,
    variables,
  });
  const edges = existing?.conversationExternalMessages.edges ?? [];
  if (edges.some(({ node }) => node.id === message.id)) return;
  cache.writeQuery<GetConversationExternalMessagesQuery>({
    query: GetConversationExternalMessagesDocument,
    variables,
    data: {
      conversationExternalMessages: {
        __typename: 'ConversationExternalMessagesConnection',
        edges: [
          ...edges,
          { __typename: 'ConversationExternalMessagesEdge', node: message },
        ],
      },
    },
  });
}
